import { DataTable } from '@optools/components/data-table/data-table';
import { DataTableColumnHeader } from '@optools/components/data-table/data-table-column-header';
import { Button } from '@optools/components/ui/button';
import { TargetView } from '@optools/services/operator-gateway/types/generated/graphql';
import { TargetStatus } from '@optools/tools/partner/components/target-status';
import { usePartnerData } from '@optools/tools/partner/hooks/usePartnerData';
import { createFileRoute, Link } from '@tanstack/react-router';
import { ColumnDef } from '@tanstack/react-table';
import { useMemo } from 'react';

export const Route = createFileRoute('/_auth/partner/targets')({
  component: RouteComponent,
});

export function RouteComponent() {
  const { channelMap, partners, targets } = usePartnerData();

  const columns = useMemo<ColumnDef<TargetView>[]>(() => {
    return [
      {
        accessorKey: 'name',
        header: ({ column }) => <DataTableColumnHeader column={column} title="Target" />,
        id: 'Target',
      },
      {
        accessorFn: (row) => {
          const channel = channelMap.get(row.channelId as number);
          return channel?.name ?? '';
        },
        accessorKey: 'channel',
        header: ({ column }) => <DataTableColumnHeader column={column} title="Channel" />,
        id: 'Channel',
      },
      {
        accessorFn: (row) => {
          const partner = partners.find((partner) => {
            return partner.targets.find(({ id }) => id === row.id);
          });

          return partner?.name;
        },
        accessorKey: 'partner',
        header: ({ column }) => <DataTableColumnHeader column={column} title="Partner" />,
        id: 'Partner',
      },

      {
        accessorKey: 'type',
        header: ({ column }) => <DataTableColumnHeader column={column} title="Type" />,
        id: 'Type',
      },
      {
        accessorKey: 'status',
        cell: ({ row }) => <TargetStatus status={row.original.status} />,
        header: ({ column }) => <DataTableColumnHeader column={column} title="Status" />,
        id: 'Status',
      },
      {
        cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <Button key={`actions-edit-${row.id}`} asChild size="sm" variant="outline">
                <Link from="/" search={{ target: row.original.name }} to="/partner/mapping">
                  Edit
                </Link>
              </Button>
            </div>
          );
        },
        id: 'edit',
      },
    ];
  }, [channelMap, partners]);

  return <DataTable columns={columns} data={targets} />;
}
